let scriptPromise = null;
function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// Opens Razorpay checkout, or auto-succeeds in demo mode.
export async function openCheckout({ payment, name, description, prefill, themeColor, onSuccess, onFail }) {
  const isDemo = payment.demo || !payment.key_id || String(payment.order_id).startsWith("order_demo_");
  if (isDemo) {
    setTimeout(() => onSuccess({
      razorpay_order_id: payment.order_id,
      razorpay_payment_id: "pay_demo_" + Math.random().toString(36).slice(2, 12),
      razorpay_signature: "demo_signature",
    }), 600);
    return;
  }
  const ok = await loadRazorpay();
  if (!ok) { onFail && onFail(new Error("Failed to load payment gateway")); return; }
  const rzp = new window.Razorpay({
    key: payment.key_id,
    amount: payment.amount,
    currency: payment.currency || "INR",
    order_id: payment.order_id,
    name,
    description,
    prefill: prefill || {},
    theme: { color: themeColor || "#1d4ed8" },
    handler: (res) => onSuccess(res),
  });
  rzp.on("payment.failed", (resp) => onFail && onFail(resp.error));
  rzp.open();
}
